import { Injectable } from '@angular/core';
import { Damage, DamageAnalysis, RoiAnalysis } from '../model/damage.model';
import { Subject } from 'rxjs';
import { LocalstorageService } from './localstorage.service';

@Injectable()
export class ClassificationService {

  damageList: DamageAnalysis[];
  roiList: RoiAnalysis[];
  damageSelected: DamageAnalysis
  roiSelected: RoiAnalysis
  public active: boolean = false
  public canSave = true
  constructor(private _localStorageService: LocalstorageService,
  ) {
    let storage = this._localStorageService.getItem('classification');
    if (storage && JSON.parse(storage).active !== undefined && this.active === false)
      this.setClassification(JSON.parse(storage).active)
  }



  // set classification
  public setClassification(isRunning: boolean) {
    this.active = isRunning
  }



  private listTags = new Subject<any>();
  listTagsObs = this.listTags.asObservable();
  setlistTags() {
    this.listTags.next()
  }

  // Selected Damage

  private listDamage = new Subject<any>();
  listDamageObs = this.listDamage.asObservable();
  setDamageList(damageList: DamageAnalysis[]) {
    this.damageList = damageList;
    if (this.damageList.length < 1) {
      this.damageSelected = undefined
    }
    this.listDamage.next(damageList)
  }
  getDamageList(): DamageAnalysis[] { return this.damageList }

  private selectedDamage = new Subject<any>();
  selectedDamageObs = this.selectedDamage.asObservable();
  setSelectedDamage(damageSelected: DamageAnalysis) {
    this.canSave = true
    console.log('damage selected classification');
    if (damageSelected !== undefined && this.damageSelected !== damageSelected && this.damageList.length > 0) {
      this.damageSelected = damageSelected;
      this.selectedDamage.next(damageSelected)
    }
  }
  getSelectedDamage(): DamageAnalysis { return this.damageSelected }

  // Selected Roi

  private selectedRoi = new Subject<any>();
  selectedRoiObs = this.selectedRoi.asObservable();
  setSelectedRoi(roiSelected: RoiAnalysis) {
    this.canSave = true
    if (roiSelected !== undefined && this.roiSelected !== roiSelected && this.damageList.length > 0) {
      this.roiSelected = roiSelected;
      this.selectedRoi.next(roiSelected)
    }
  }
  getSelectedRoi(): RoiAnalysis { return this.roiSelected }


  private hideDamages = new Subject<any>();
  hideDamagesObs = this.hideDamages.asObservable();
  setHideDamages(hide: boolean) {
    this.hideDamages.next(hide)
  }

  private createAnnotation = new Subject<any>();
  createAnnotationObs = this.createAnnotation.asObservable();
  newAnnotation(damageSelected: Damage) {
    this.createAnnotation.next(damageSelected)
  }

}



// WEBPACK FOOTER //
// ./src/app/service/classification.service.ts